export default __webpack_public_path__ + "static/media/diamond-color-table_over-md.33086e07.png";